export default "__VITE_ASSET__sBXWOzD9__"